import Pill from '@/components/Pill'
import { DOCUMENT_CATEGORY_PILLS } from './documentsDemoData'
import DocumentsViewToggle from './DocumentsViewToggle'
import styles from './documentsPage.module.scss'

/** @typedef {import('./documentsDemoData').DocumentCategoryFilter} DocumentCategoryFilter */
/** @typedef {import('./documentsConstants').DocumentsViewMode} DocumentsViewMode */

/**
 * @param {{
 *   activeCategory: DocumentCategoryFilter,
 *   onCategoryChange: (category: DocumentCategoryFilter) => void,
 *   view: DocumentsViewMode,
 *   onViewChange: (view: DocumentsViewMode) => void,
 * }} props
 */
export default function DocumentsToolbar({
  activeCategory,
  onCategoryChange,
  view,
  onViewChange,
}) {
  return (
    <div className={styles.toolbar}>
      <div className={styles.pillRow} role="group" aria-label="Document categories">
        {DOCUMENT_CATEGORY_PILLS.map((pill) => (
          <Pill
            key={pill.id}
            label={pill.label}
            active={activeCategory === pill.id}
            onClick={() => onCategoryChange(pill.id)}
            shape="pill"
          />
        ))}
      </div>

      <div className={styles.toolbarActions}>
        <DocumentsViewToggle view={view} onViewChange={onViewChange} />
      </div>
    </div>
  )
}
